'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _options = require('../options');

var _options2 = _interopRequireDefault(_options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagsInputOptions = function TagsInputOptions(props) {
  var options = props.options,
      className = props.className,
      type = props.type,
      id = props.id,
      onChange = props.onChange,
      maxShown = props.maxShown,
      initShown = props.initShown;

  var horizontal = type === 'pills' ? true : false;

  if (type === 'none') {
    return _react2.default.createElement('noscript', null);
  }

  return _react2.default.createElement(_options2.default, {
    className: 'pxl-tagsinput-autocomplete__options',
    id: id + 'options',
    initShown: initShown,
    loadMore: true,
    maxShown: maxShown,
    onChange: onChange,
    options: options,
    optionProps: { className: className },
    syncOnUpdate: true,
    type: type,
    horizontal: horizontal
  });
};

TagsInputOptions.propTypes = {
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  initShown: _propTypes2.default.number,
  maxShown: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.array,
  type: _propTypes2.default.oneOf(['none', 'checklist', 'pills'])
};

TagsInputOptions.defaultProps = {
  className: '',
  initShown: 5,
  options: [],
  type: 'none'
};

exports.default = TagsInputOptions;